import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ExitToApp from '@material-ui/icons/ExitToApp';
import ZoomOutIcon from '@material-ui/icons/ZoomOutMap';
import Switch from '@material-ui/core/Switch';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PeopleIcon from '@material-ui/icons/People';
import StoreIcon from '@material-ui/icons/Store';
import EditIcon from '@material-ui/icons/Edit';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import AssignmentIcon from '@material-ui/icons/Assignment';
import CloseIcon from '@material-ui/icons/Close';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import SearchIcon from '@material-ui/icons/Search';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ErrorIcon from '@material-ui/icons/Error';
import PersonPinIcon from '@material-ui/icons/PersonPinCircle';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';

import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import LinearProgress from '@material-ui/core/LinearProgress';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import Chip from '@material-ui/core/Chip';
import Checkbox from '@material-ui/core/Checkbox';
import Snackbar from '@material-ui/core/Snackbar';

import FileUploader from 'react-firebase-file-uploader';

import _ from "lodash";
import firebase from '../../Firebase';
import AsyncStorage from '@callstack/async-storage';
import { connect } from 'react-redux'

import Mainmenu from '../../components/mainmenu';

const drawerWidth = 240;

const DialogTitle = withStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit * 2,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500],
  },
}))(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing.unit * 2,
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    borderTop: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit,
  },
}))(MuiDialogActions);

const styles = theme => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '0.4em'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: '#f2a811',
      borderRadius: '5px',
    }
  },
  hide: {
    display:'none',
  },
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    backgroundColor: '#f2a811',
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    // justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  toolbarAvatar: {
    borderRadius: 0,
    width: 170,
    left: 10,
  },
  toolbarIconButton:{
    right:0,
    position:'absolute'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9,
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '100vh',
    overflow: 'auto',
  },
  chartContainer: {
    marginLeft: -22,
  },
  tableContainer: {
    height: 320,
  },
  h5: {
    marginBottom: theme.spacing.unit * 2,
  },
  loadingColorPrimary: {
    backgroundColor: '#f2a811',
  },
  loadingBarColorPrimary: {
    backgroundColor: '#b1730d',
  },
  button: {
    marginBottom: 15,
    color: '#fff',
    backgroundColor: '#f2a811',
    '&:hover': {
      backgroundColor: '#b1730d',
    },
  },
  buttonDanger: {
    marginBottom: 15,
    color: '#fff',
    backgroundColor: '#B22222',
    '&:hover': {
      backgroundColor: '#8B0000',
    },
  },
  form: {
    width: '100%',
    //marginTop: theme.spacing.unit,
  },
  label: {
    '&$cssFocused': {
      color: '#f2a811',
    },
  },
  input: {
    '&:after': {
      borderBottomColor: '#f2a811',
    },
  },
  buttonProgress: {
    color: "#fff",
  },
  avatarProgress: {
    color: '#f2a811',
    zIndex: 999,
  },
  avatarProgressTxt: {
    color: '#f2a811',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  checkbox: {
    color: '#f2a811',
    '&$checked': {
      color: '#f2a811',
    },
  },
  table: {
    width: '100%',
    overflowX: 'auto',
  },
  snackbar_icon: {
    fontSize: 20,
  },
  color_b1730d:{
    color:"#b1730d"
  },
  div_100p:{
    width: "100%",
    marginTop: 15,
    marginBottom: 15,
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const formatDate = (date) => {
  let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
};

class Inventory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      drawer: true,
      dialog: false,
      dialogType: "add",
      loading: true,
      adding: false,
      editing: false,
      deleting: false,
      pulling_out: false,
      categories: [],
      sellers: [],
      unfilteredInventory: [],
      inventory: [],
      transactions: [],

      searchedTxt: "",
      searchedArr: [],

      imageUploading: false,
      imageUploadProgress: -1,

      inventory_id: "",
      SKU: "",
      category: [],
      created_at: "",
      discount: "",
      discount_until: formatDate(new Date()),
      name: "",
      description: "",
      image: "",
      price: "",
      size: "",
      stocks: 0, 
      updated_at: "",

      pullout_stocks: "",

      menus: [],
      anchorEl: null,

      config:{},

      discountSelect: false,
      form_errors:[],
      userID: [],
      sellers: []
    };
  }

  async componentDidMount()
  {


    let session = await AsyncStorage.multiGet(["user","uid"])

    this.props.setUser(session[1][1], session[0][1])
   
    this.setState({userID: session[1][1]})
    let that = this

    let queries = [
          firebase.firestore().collection('config'),
          firebase.firestore().collection('categories'),
          firebase.firestore().collection('inventory'),
          firebase.firestore().collection('users').where('roles','array-contains','seller')
        ]

    Promise.all(queries).then(values=>{
      
      if(values[0])
      {
          values[0].get().then(querySnapshot => { 
              querySnapshot.forEach(function(doc) {
                  that.setState({config: doc.data() })
              });
          })
      }

      if(values[1])
      { 

          values[1].get().then(querySnapshot => {
                
              querySnapshot.forEach(function(doc) {
                  let categories = that.state.categories
                  categories.push(doc.data())
                  that.setState({categories: categories })
              });
          })

      }

      if(values[2])
      { 


          values[2].onSnapshot(function(querySnapshot){
                  let inventory = []
              querySnapshot.forEach(function(doc) {
                  let obj = doc.data();
                  obj.id = doc.id
                  inventory.push(obj)
                  that.setState({unfilteredInventory: inventory, inventory: inventory, loading:false, user: JSON.parse( session[0][1] ) })
              });

          })

      }

      if(values[3])
      { 


          values[3].onSnapshot(function(querySnapshot){
                  let sellers = []
              querySnapshot.forEach(function(doc) {
                  let obj = doc.data();
                  obj.id = doc.id
                  sellers.push(obj)
                  that.setState({sellers: sellers})

                  console.log('sellers',sellers)
              });

          })

      }

      that.setState({loading:false, user: JSON.parse( session[0][1] ) })

     
      //this.setState( { categories: categories, inventory: inventory, user: JSON.parse( session[0][1] ),  loading:false })

    })



  }

  async logout(){
    try {
      /*await AsyncStorage.removeItem('user');*/
      this.props.navigation.navigate('Login');
    } catch (error) {
      console.log(error);
    }
  }

  toggleDrawer(){
    this.setState({ drawer:!this.state.drawer });
  }

  toggleDialog(){
    this.setState({ dialog:!this.state.dialog, SKU:"", name:"", description:"", image:"", price:"", size:"", stocks:"", category:[], adding:false, editing:false, deleting:false });
  }

  toggleAdd(obj){
    this.toggleDialog();
    this.setState({dialogType:"add"});
  }

  toggleEdit(obj){
   
    this.toggleDialog();
    this.setState({dialogType:"edit", inventory_id:obj.id, SKU:obj.SKU, category:obj.category, created_at:obj.created_at, discount:obj.discount, discount_until:obj.discount_until, name:obj.item, description:obj.itemDesc, image:obj.itemImage, price:obj.seller_price, size:obj.size, stocks:obj.stock, updated_at:obj.updated_at,});
  }

  toggleDelete(obj){
    this.toggleDialog();
    this.setState({dialogType:"delete", inventory_id:obj.id});
  }

  togglePullout(obj){
    this.toggleDialog();
    this.setState({dialogType:"pullout", inventory_id:obj.id, name:obj.item, image:obj.itemImage, stocks:obj.stock, pullout_stocks:"1"});
  }

  toggleMenu(event, i, bool){
    var menus = this.state.menus;
    menus[i] = bool;
    this.setState({menus:menus, anchorEl:(bool ? event.currentTarget : null )});
  }

  stringify(arr){
    let str = "";
    if(arr.length == 1)
      str = arr[0];
    else{
      arr.map((a, i) => {
        if(i == (arr.length-1))
          str += a;
        else
          str += a+", ";
      });
    }
    return str;
  }

  onSearch(s){
   
    if(s!=''){
      let excludeProjects = [s];
      let inv = []
       inv = _.filter(this.state.unfilteredInventory, function(o) { 
        return o.item.toLowerCase().includes(s.toLowerCase()) 
        || (o.actual_price+"").toLowerCase().includes(s.toLowerCase())
        || (o.size+"").toLowerCase().includes(s.toLowerCase())
        || (o.stock+"").toLowerCase().includes(s.toLowerCase())
      });

      this.setState({inventory: inv})
    }else{
         this.setState({inventory: this.state.unfilteredInventory})
    }
   
  }

  onCategorySelect(e){
    this.setState({ category: e.target.value });
  }

  add(){

    let errors = [];

    if(this.state.adding)
      errors.push("currently adding");
    if(this.state.image == "")
      errors.push("image is required");
    if(this.state.name == "")
      errors.push("name is required");
    /*if(this.state.description == "")
      errors.push("description is required");*/
    if(this.state.price == "")
      errors.push("price is required");
    if(this.state.size == "")
      errors.push("size is required");
    if(this.state.stocks == "")
      errors.push("stocks is required");
    if(this.state.discount < 0 || this.state.discount > 50)
      errors.push("discount should only range from 0 to 50");
    if(this.state.discount > 0 && (new Date(this.state.discount_until) < new Date()))
      errors.push("discount expiration should not be less than current date");

    this.setState({form_errors:errors});
    
    if(_.isEmpty(errors)){

     
      this.setState({adding:true});
      let discount_price = this.state.price - (this.state.price * (this.state.discount/100));
      let actual_price = discount_price  * ( ( 100 + Number(this.state.config.company_markup) ) / 100 )
      firebase.firestore().collection('inventory').doc().set({
        seller_price: this.state.price,
        actual_price: actual_price,
        discount_price: discount_price,
        category: this.state.category,
        created_at: firebase.firestore.FieldValue.serverTimestamp(),
        discount: this.state.discount == "" ? 0 : this.state.discount,
        discount_until: (this.state.discount == 0 || this.state.discount == "") ? null : this.state.discount_until,  
        item: this.state.name,
        itemDesc: this.state.description,
        itemImage: this.state.image,
        seller: this.state.userID,    
        size: this.state.size,
        stock: this.state.stocks,
        live: true,
        updated_at: null,
      }).then(() => {
        this.toggleDialog();
      }).catch( error => {
        console.log(error);
        this.toggleDialog();
      });
    }
  }

  edit(){
    const t = this;
    let errors = [];

   if(this.state.adding)
      errors.push("currently adding");
    if(this.state.image == "")
      errors.push("image is required");
    if(this.state.name == "")
      errors.push("name is required");
    /*if(this.state.description == "")
      errors.push("description is required");*/
    if(this.state.price == "")
      errors.push("price is required");
    if(this.state.size == "")
      errors.push("size is required");
    if(this.state.stocks == "")
      errors.push("stocks is required");
    if(this.state.discount < 0 || this.state.discount > 50)
      errors.push("discount should only range from 0 to 50");
    if(this.state.discount > 0 && (new Date(this.state.discount_until) < new Date()))
      errors.push("discount expiration should not be less than current date");

    t.setState({form_errors:errors})

    if(_.isEmpty(errors)){
      t.setState({editing:true});
      let discount_price = this.state.price - (this.state.price * (this.state.discount/100));
      let actual_price = discount_price + (discount_price * (this.state.config.company_markup/100));
    
      
      firebase.firestore().collection('inventory').doc(t.state.inventory_id).update({
        seller_price: this.state.price,
        actual_price: actual_price,
        discount_price: discount_price,
        category: this.state.category,
        created_at: firebase.firestore.FieldValue.serverTimestamp(),
        discount: this.state.discount == "" ? 0 : this.state.discount,
        discount_until: (this.state.discount == 0 || this.state.discount == "") ? null : this.state.discount_until,  
        item: this.state.name,
        itemDesc: this.state.description,
        itemImage: this.state.image,
        seller: "ADMIN",    
        size: this.state.size,
        stock: this.state.stocks,
        live: true,
        updated_at: null,
      }).then(() => {
        t.toggleDialog();
      }).catch( error => {
        console.log(error);
        t.toggleDialog();
      });
    }
  }

  delete(){
    const t = this;
    t.setState({deleting:true});
    firebase.firestore().collection("inventory").doc(t.state.inventory_id).delete().then(function() {
      t.toggleDialog();
    }).catch(function(error) {
      console.error("Error removing document: ", error);
    });
  }

  pullout(){
    this.setState({pulling_out:true});
    firebase.firestore().collection('transactions').doc().set({
      type: "pullout",
      item: this.state.inventory_id,
      stock: this.state.pullout_stocks,
      created_at: firebase.firestore.FieldValue.serverTimestamp(),
      updated_at: null,
    }).then(() => {
      this.toggleDialog();
    }).catch( error => {
      console.log(error);
      this.toggleDialog();
    });
  }

  getTotalStock(transactions, inv_id, inv_stock){
    let pulled_out_stock = 0;
    let total_stock = 0;

    transactions.map(t => {
      if(t.type == "pullout" && t.item == inv_id)
        pulled_out_stock = pulled_out_stock + t.stock;
    });

    total_stock = total_stock + (inv_stock - pulled_out_stock);

    return total_stock;
  }

  goTo(p){
    this.props.navigation.navigate(p);
  }

  checkInventoryTableRows(itr){
    let totalUndefined = 0;

    itr.map(i => {
      if(i == undefined)
        totalUndefined++;
    });

    if(itr.length == totalUndefined)
      return true;
    else
      return false;
  }

  render() {
    const { classes } = this.props;
    let discountSelectMenus = [];
    let form_errors = this.state.form_errors;
    let user = this.state.user;
    let sellers = this.state.sellers;
    let categories = this.state.categories;
    let inventory = this.state.inventory;
    let transactions = this.state.transactions;
    let summary = {};
    let addingErrorSnackbar;
    let categoriesMenu;
    let inventoryTableRows;

    if(!_.isEmpty(form_errors)){
      let form_errors_list;
      form_errors_list = form_errors.map(e => {
        return ( <li>{e}</li> );
      });
      addingErrorSnackbar = [
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={true}
          autoHideDuration={6000}
          onClose={() => this.setState({form_errors:[]})}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={
            <div id="message-id">
              <p><ErrorIcon className={classes.snackbar_icon} />{ " Add failed" }</p>
              <ul>{ form_errors_list }</ul>
            </div>
          }
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={classes.close}
              onClick={() => this.setState({form_errors:[]})}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      ];
    }

    if(!_.isEmpty(categories)){
      categoriesMenu = categories.map((c, i) => {
        return(
          <MenuItem key={i} value={c.name}>
            <Checkbox color="#f2a811" className={classes.checkbox} checked={this.state.category.indexOf(c.name) > -1} />
            <ListItemText primary={c.name} />
          </MenuItem>
        );
      });
    }
    
    if(!_.isEmpty(inventory))
    {

       inventoryTableRows = inventory.map((inv, i) => {
      
       let sellers = this.state.sellers
       let seller = _.find(sellers,{id: inv.seller} )
       console.log('seller',seller)
      
       return (

          <TableRow key={i}>
            <TableCell component="th" scope="row"><Avatar alt={inv.item} src={inv.itemImage} /></TableCell>
            <TableCell component="th" scope="row">{inv.item}</TableCell>
            <TableCell component="th" scope="row">{ !_.isEmpty(seller) ? seller.firstName+" "+seller.lastName : ''}</TableCell>
            <TableCell component="th" scope="row">{'₱ '+inv.seller_price}</TableCell>
            <TableCell component="th" scope="row">{inv.size}</TableCell>
            <TableCell component="th" scope="row">{inv.stock}</TableCell>
            <TableCell component="th" scope="row">{this.stringify(inv.category)}</TableCell>
            <TableCell component="th" scope="row">
              
              <IconButton
                aria-label="More"
                aria-owns={this.state.menus[i] ? 'render-props-menu-'+i : undefined}
                aria-haspopup="true"
                onClick={(e) => this.toggleMenu(e, i, true)}
              >
                <MoreVertIcon />
              </IconButton>
              <Menu id={"render-props-menu-"+i} open={this.state.menus[i]} anchorEl={this.state.anchorEl} onClose={(e) => this.toggleMenu(e, i, false)}>
                <MenuItem onClick={() => { if(!this.state.adding || !this.state.deleting){ this.toggleEdit(inv) } }}>
                  <ListItemIcon><EditIcon /></ListItemIcon>
                  <Typography variant="inherit" noWrap>Edit</Typography>
                </MenuItem>
                
                {/*<MenuItem onClick={() => { if(!this.state.adding || !this.state.deleting){ this.togglePullout(inv) } }}>
                    <ListItemIcon><ZoomOutIcon /></ListItemIcon>
                    <Typography variant="inherit" noWrap>Pullout</Typography>
                </MenuItem>*/}
              
                <MenuItem onClick={() => { if(!this.state.adding || !this.state.deleting){ this.toggleDelete(inv) } }}>
                  <ListItemIcon><DeleteForeverIcon /></ListItemIcon>
                  <Typography variant="inherit" noWrap>Delete</Typography>
                </MenuItem>
                <MenuItem onClick={(e) => this.toggleMenu(e, i, false)}>
                  <ListItemIcon><CloseIcon /></ListItemIcon>
                  <Typography variant="inherit" noWrap>Close</Typography>
                </MenuItem>
              </Menu>
            </TableCell>
          </TableRow>
         )


        
      });

    }
    

    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position="absolute"
          className={classNames(classes.appBar, this.state.drawer && classes.appBarShift)}
        >
          <Toolbar disableGutters={!this.state.drawer} className={classes.toolbar}>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={() => this.toggleDrawer()}
              className={classNames(
                classes.menuButton,
                this.state.drawer && classes.menuButtonHidden,
              )}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              className={classes.title}
            >
              Inventory
            </Typography>
            <IconButton color="inherit" onClick={() => this.goTo("Login")}>
              <ExitToApp />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          classes={{
            paper: classNames(classes.drawerPaper, !this.state.drawer && classes.drawerPaperClose),
          }}
          open={this.state.drawer}
        >
          <div className={classes.toolbarIcon}>
            <Avatar src="https://firebasestorage.googleapis.com/v0/b/easysuki-dev.appspot.com/o/assets%2FeasySuki-toolbar.png?alt=media&token=3b713ebc-804c-4e5f-8362-aa5d48f5ff29" className={classes.toolbarAvatar}/>
            <IconButton onClick={() => this.toggleDrawer()} className={classes.toolbarIconButton}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Divider />
          <Mainmenu navigation={this.props.navigation} active="inventory"/>
          
        </Drawer>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <div className={classes.tableContainer}>
            { !this.state.loading &&
              [
                <Grid key={0} container spacing={24} className={!(this.state.user.roles.includes("seller")) && classes.hide}>
                  <Grid item xs={12} sm={12} md={10} lg={10}>
                    <FormControl fullWidth className={classes.margin}>
                      <Input
                        placeholder="Search"
                        className={classes.input}
                        onChange={event => this.onSearch(event.target.value)}
                        startAdornment={<InputAdornment position="start"><SearchIcon/></InputAdornment>}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={2}>
                    <Button
                      fullWidth
                      variant="contained"
                      className={classes.button}
                      onClick={() => { if(!this.state.adding || !this.state.editing){ this.toggleAdd() } }}
                    >
                      Add Item
                    </Button>
                  </Grid>
                </Grid>,
                <br key={1} />,
                <Grid key={2} container spacing={24}>
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <Paper>
                      <center>
                        {"Unique items"}
                        <Typography className={classes.color_b1730d} component="h2" variant="display1" gutterBottom>
                          { _.isEmpty(inventory) ? 0 : this.state.inventory.length }
                        </Typography>
                      </center>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <Paper>
                      <center>
                        {"Total stock"}
                        <Typography className={classes.color_b1730d} component="h2" variant="display1" gutterBottom>
                          { _.isEmpty(inventory) ? 0 : _.sumBy(inventory, function(o) { return Number(o.stock) } ) }
                        </Typography>
                      </center>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <Paper>
                      <center>
                        {"No Stock"}
                        <Typography className={classes.color_b1730d} component="h2" variant="display1" gutterBottom>
                          { _.isEmpty(inventory) ? 0 : _.sumBy(inventory, function(o) { return Number(o.stock) == 0  } ) }
                        </Typography>
                      </center>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <Paper>
                      <center>
                        {"Worth"}
                        <Typography className={classes.color_b1730d} component="h2" variant="display1" gutterBottom>
                          { _.isEmpty(inventory) ? 0 : "₱ "+ Number( Number( _.sumBy(inventory, function(o) { return Number( o.actual_price*o.stock) } ) ).toFixed(2) ).toLocaleString() }
                        </Typography>
                      </center>
                    </Paper>
                  </Grid>
                  
                </Grid>,
                <br key={3} />,
              ]
            }
            { this.state.loading ?
                <Paper className={classes.root}>
                  <Table className={classes.table}>
                    <LinearProgress
                      classes={{
                        colorPrimary: classes.loadingColorPrimary,
                        barColorPrimary: classes.loadingBarColorPrimary,
                      }}
                    />
                  </Table>
                </Paper>
              :
                <Paper className={classes.root}>
                  
                  <Table className={classes.table}>
                      <TableHead key={1}>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Seller</TableCell>
                            <TableCell>Price</TableCell>
                            <TableCell>Size</TableCell>
                            <TableCell>Stock</TableCell>
                            <TableCell>Categories</TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                        </TableHead>,
                        <TableBody key={2}>
                          {inventoryTableRows}
                        </TableBody>      
                  </Table>

                </Paper>
            }
          </div>
        </main>
        <Dialog
          onClose={() => {this.setState({dialog:false})}}
          aria-labelledby="customized-dialog-title"
          open={this.state.dialog}
        >
          <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
            { this.state.dialogType == "add" && "Add Inventory" }
            { this.state.dialogType == "edit" && "Edit Inventory" }
            { this.state.dialogType == "delete" && "Confirm Delete" }
            { this.state.dialogType == "pullout" && "Pullout" }
          </DialogTitle>
          <DialogContent>
            { this.state.dialogType == "delete" ?
                "Are you sure you want to delete this item in the inventory?"
              :
                <div>
                  { this.state.dialogType == "add" || this.state.dialogType == "edit" ?
                      <form className={classes.form}>
                        <center>
                          <label>
                            { this.state.imageUploadProgress == -1 ?
                                <Avatar src={ this.state.image == "" ? "images/camera.png" : this.state.image} style={{pointer:'cursor', width:80, height:80, backgroundColor:"#f2a811"}}/>
                              :
                                <CircularProgress size={80} className={classes.avatarProgress} />
                            }
                            <FileUploader
                              hidden
                              accept="image/*"
                              name="avatar"
                              randomizeFilename
                              storageRef={firebase.storage().ref('/inventory')}
                              onUploadStart={() => this.setState({imageUploading:true})}
                              onUploadError={(error) => console.log(error)}
                              onUploadSuccess={(filename) => {
                                firebase.storage().ref("/inventory").child(filename).getDownloadURL().then((url) => {
                                  this.setState({ image:url, imageUploadProgress:-1 });
                                });
                              }}
                              onProgress={(progress) => this.setState({imageUploadProgress:progress})}
                            />
                          </label>
                          { this.state.imageUploadProgress != -1 && [<br key={0}/>, <label key={1} className={classes.avatarProgressTxt}>{ 'Uploading... '+this.state.imageUploadProgress+' %' }</label>] }
                        </center>
                        <FormControl margin="normal" required fullWidth>
                          <InputLabel className={classes.label}>Category</InputLabel>
                          <Select
                            multiple
                            value={this.state.category}
                            className={classes.input}
                            onChange={(e) => this.onCategorySelect(e)}
                            input={<Input id="select-multiple-chip" />}
                            renderValue={selected => (
                              <div className={classes.chips}>
                                {selected.map((value, i) => (
                                  <Chip key={i} label={value} className={classes.chip} />
                                ))}
                              </div>
                            )}
                            MenuProps={MenuProps}
                          >
                            { categoriesMenu }
                          </Select>
                        </FormControl>
                        
                        <FormControl margin="normal" required fullWidth>
                          <InputLabel className={classes.label}>Name</InputLabel>
                          <Input id="name" name="name" autoComplete="name" value={this.state.name} className={classes.input}
                            onChange={event => {
                              const { value } = event.target;
                              this.setState({ name: value });
                            }}
                          />
                        </FormControl>
                        <FormControl margin="normal" required fullWidth>
                          <InputLabel className={classes.label}>Descrption</InputLabel>
                          <Input id="description" name="description" autoComplete="description" value={this.state.description} multiline rows="4" className={classes.input}
                            onChange={event => {
                              const { value } = event.target;
                              this.setState({ description: value });
                            }}
                          />
                        </FormControl>
                        <FormControl margin="normal" required fullWidth>
                          <InputLabel className={classes.label}>Price</InputLabel>
                          <Input id="price" name="price" autoComplete="price" value={this.state.price} className={classes.input}
                            startAdornment={<InputAdornment position="start">₱</InputAdornment>}
                            onChange={event => {
                              const { value } = event.target;
                              this.setState({ price: value });
                            }}

                            onKeyDown = {

                              (e) => {
                                  let charCode = (e.which) ? e.which : e.keyCode
                                  let price = this.state.price

                                  if (charCode == '190' || charCode == '8' || charCode == '46' ||  (charCode >= '48' && charCode <= '57')){}else{
                                    e.preventDefault()
                                  }

                                    
                              }

                            }
                            

                            
                          />
                        </FormControl>
                        <FormControl margin="normal" required fullWidth>
                          <InputLabel className={classes.label}>Discount</InputLabel>
                          <Input id="discount" name="discount" autoComplete="discount" value={this.state.discount} className={classes.input}
                            endAdornment={<InputAdornment position="start">%</InputAdornment>}
                            onChange={event => {
                              const { value } = event.target;
                              this.setState({ discount: value });
                            }}

                            onKeyDown = {

                              (e) => {
                                  let charCode = (e.which) ? e.which : e.keyCode
                                
                                  if ( charCode == '8' || charCode == '46' ||  (charCode >= '48' && charCode <= '57')){}else{
                                    e.preventDefault()
                                  }

                                    
                              }

                            }

                          />
                        </FormControl>
                        <FormControl margin="normal" required fullWidth>
                          <InputLabel className={classes.label} shrink={true} disableAnimation={false}>Discount Until</InputLabel>
                          <Input disabled={this.state.discount == 0 ? true : false} type="date" id="discount_until" name="discount_until" autoComplete="discount_until" value={this.state.discount_until} className={classes.input}
                            onChange={event => {
                              const { value } = event.target;
                              this.setState({ discount_until: formatDate(value) });
                            }}
                          />
                        </FormControl>
                        <FormControl margin="normal" required fullWidth>
                          <InputLabel className={classes.label}>Size</InputLabel>
                          <Input id="size" name="size" autoComplete="size" value={this.state.size} className={classes.input}
                            onChange={event => {
                              const { value } = event.target;
                              this.setState({ size: value });
                            }}
                          />
                        </FormControl>
                        <FormControl margin="normal" required fullWidth>
                          <InputLabel className={classes.label}>Stocks</InputLabel>
                          <Input type="number" disabled={ this.state.dialogType == "edit" ? false : false } id="stocks" name="stocks" autoComplete="stocks" value={this.state.stocks} className={classes.input}
                            onChange={event => {
                              const { value } = event.target;
                              this.setState({ stocks: value });
                            }}

                            onKeyDown = {

                              (e) => {
                                  let charCode = (e.which) ? e.which : e.keyCode
                                
                                  if ( charCode == '8' || charCode == '46' ||  (charCode >= '48' && charCode <= '57')){}else{
                                    e.preventDefault()
                                  }

                                    
                              }

                            }
                          />
                        </FormControl>
                      </form>
                    :
                      <form className={classes.form}>
                        <center>
                          <label>
                            { this.state.image == "" ?
                                <Avatar style={{pointer:'cursor', width:80, height:80, backgroundColor:"#f2a811"}}>
                                  <StoreIcon style={{ width:50, height:50 }} />
                                </Avatar>
                              :
                                <Avatar src={this.state.image} style={{pointer:'cursor', width:80, height:80, backgroundColor:"#f2a811"}}/>
                            }
                            <p>{ this.state.name }</p>
                          </label>
                        </center>
                        <FormControl margin="normal" required fullWidth>
                          <InputLabel className={classes.label}>Stock</InputLabel>
                          <Input type="number" id="stock" name="stock" autoComplete="stock" value={this.getTotalStock(transactions, this.state.inventory_id, this.state.stocks)} className={classes.input}
                            inputProps={{ min:1, max:this.getTotalStock(transactions, this.state.inventory_id, this.state.stocks), step:1 }}
                            onChange={event => {
                              const { value } = event.target;
                              if(parseFloat(value) >= 1 || parseFloat(value) <= parseFloat(this.state.pullout_stocks))
                                this.setState({ pullout_stocks: value });
                            }}
                          />
                        </FormControl>
                      </form>
                  }
                </div>
            }
          </DialogContent>
          <DialogActions>
            { this.state.dialogType == "add" &&
                <Button className={classes.button} onClick={() => this.add()} color="primary">
                  { this.state.adding ?
                      <CircularProgress size={24} className={classes.buttonProgress} />
                    :
                      "Add"
                  }
                </Button>
            }
            { this.state.dialogType == "edit" &&
                <Button className={classes.button} onClick={() => this.edit()} color="primary">
                  { this.state.editing ?
                      <CircularProgress size={24} className={classes.buttonProgress} />
                    :
                      "Edit"
                  }
                </Button>
            }
            { this.state.dialogType == "delete" &&
                <Button className={classes.button} onClick={() => this.delete()} color="primary">
                  { this.state.deleting ?
                      <CircularProgress size={24} className={classes.buttonProgress} />
                    :
                      "Yes"
                  }
                </Button>
            }
            { this.state.dialogType == "pullout" &&
                <Button className={classes.button} onClick={() => this.pullout()} color="primary">
                  { this.state.deleting ?
                      <CircularProgress size={24} className={classes.buttonProgress} />
                    :
                      "Pullout"
                  }
                </Button>
            }
            { this.state.dialogType == "delete" ?
                <Button className={classes.button} onClick={() => this.setState({ dialog:false })} color="primary">
                  No
                </Button>
              :
                <Button className={classes.button} onClick={() => this.toggleDialog()} color="primary">
                  Close
                </Button>
            }
          </DialogActions>
        </Dialog>
        { addingErrorSnackbar }
      </div>
    );
  }
}

Inventory.propTypes = {
  classes: PropTypes.object.isRequired,
};


const mapStateToProps = (state) => {
  return { state: state }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setUser: (userid,user) => dispatch({type: "SET_USER", payload: { userid: userid, user: user }})
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(withStyles(styles)(Inventory));
